import React, { useCallback, useState, useRef } from 'react';
import AvatarEditor from 'react-avatar-editor';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { base64ToFile } from '../../utils/generic';
import { Container, Close, AvatarContainer, ZoomInput, ConfirmBtn } from './styles';

export interface AvatarChange {
  image: string;
  formData: FormData;
}

interface Props {
  src?: string;
  show: boolean;
  cropImage: (val: AvatarChange) => void;
  onClose: () => void;
  onConfirm: () => void;
}

const AvatarCrop = ({ src, show, onClose, cropImage, onConfirm }: Props) => {
  const { t } = useStoreTranslation();

  const editor = useRef<AvatarEditor>(null);
  const [zoom, setZoom] = useState<number>(1);

  const handleZoom = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setZoom(Number(e.target.value));
  }, []);

  const handleConfirm = useCallback(async () => {
    const img = editor?.current?.getImageScaledToCanvas().toDataURL();

    if (img) {
      const file = await base64ToFile(img, 'png');
      const data = new FormData();
      data.append('file', file ?? '', 'filename.png');
      cropImage({
        formData: data,
        image: img,
      } as AvatarChange);
    }

    onConfirm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!src) return <></>;

  return (
    <ApplicationOverlayContent show={show} onClose={onClose}>
      <Container>
        <Close src="/images/close.svg" onClick={onClose} />
        <AvatarContainer>
          <AvatarEditor
            ref={editor}
            image={src ?? ''}
            width={350}
            height={350}
            border={0}
            borderRadius={350}
            color={[255, 255, 255, 0.6]}
            scale={zoom}
            rotate={0}
          />
          <ZoomInput name="scale" type="range" onChange={handleZoom} min="1" max="2" step="0.01" defaultValue="1" />
          <ConfirmBtn onClick={handleConfirm} value={t('avatarCrop.confirmBtn')} />
        </AvatarContainer>
      </Container>
    </ApplicationOverlayContent>
  );
};

export default AvatarCrop;
